const MenuItems = (type: string) => {
  let SuperAdminMenu = [
    {
      name: "Dashboard",
      iconClassname: "icon-dashboard",
      path: "/super-admin-dashboard",
      menuClassname: "nav-link",
    },
    {
      name: "Facilities",
      iconClassname: "icon-facilities",
      path: "/facilities",
      menuClassname: "nav-link",
    },
    {
      name: "Sports",
      iconClassname: "icon-sports",
      path: "/sports",
      menuClassname: "nav-link",
    },
    {
      name: "Courts",
      iconClassname: "icon-courts",
      path: "/courts",
      menuClassname: "nav-link",
    },
    {
      name: "Users",
      iconClassname: "icon-users",
      path: "/users",
      menuClassname: "nav-link",
    },
    {
        name:"Coaching",
        iconClassname:"icon-coaching",
        path:"/coaching",
        menuClassname:"nav-link"
    },
    {
      name: "Booking",
      iconClassname: "icon-booking",
      path: "/booking",
      menuClassname: "nav-link",
      subMenu: [
        {
          name: "Court",
          path: "/court-booking",
          menuClassname: "nav-link",
        },
        {
            name:"Associate",
            path:"/associate-booking",
            menuClassname:"nav-link"
        },
        {
            name:"Coaching Session",
            path:"/coaching-session-booking",
            menuClassname:"nav-link"
        },
      ],
    },
    {
      name: "Stock",
      iconClassname: "icon-stock",
      path: "/stocks",
      menuClassname: "nav-link",
      subMenu: [
        {
          name: "Sales",
          path: "/sell-stock",
          menuClassname: "nav-link",
        },
        {
          name: "Services",
          path: "/rent-stock",
          menuClassname: "nav-link",
        },
      ],
    },
    {
      name: "Notification",
      iconClassname: "icon-notification-icon",
      path: "/notification",
      menuClassname: "nav-link",
      subMenu: [
        {
          name: "Promotional",
          path: "/promotional-notification",
          menuClassname: "nav-link",
        },
        {
          name: "System",
          path: "/system-notification",
          menuClassname: "nav-link",
        },
      ],
    },
    {
      name: "Discount Offers",
      iconClassname: "icon-promotions",
      path: "/discount-offers",
      menuClassname: "nav-link",
    },
    {
      name: "Settings",
      iconClassname: "icon-settings",
      path: "/power-play-setting",
      menuClassname: "nav-link",
    },
  ];

  let OfficeAdminMenu = [
    {
      name: "Dashboard",
      iconClassname: "icon-dashboard",
      path: "/office-admin-dashboard",
      menuClassname: "nav-link",
    },
    {
      name: "Booking",
      iconClassname: "icon-booking",
      path: "/booking",
      menuClassname: "nav-link",
      subMenu: [
        {
          name: "Court",
          path: "/court-booking",
          menuClassname: "nav-link",
        },
        {
          name: "Coaching Session",
          path: "/coaching-session-booking",
          menuClassname: "nav-link",
        },
      ],
    },
  ];

  if (type === "SUPER_ADMIN") return SuperAdminMenu;
  if (type === "OFFICE_ADMIN") return OfficeAdminMenu;


};

export { MenuItems };
